import { Link } from "@tanstack/react-router";
import { twJoin } from "tailwind-merge";

import type { ModifierGroupListItem } from "~/api-refs";

interface ModifierGridProps {
  modifierGroups: ModifierGroupListItem[];
  menuId: string;
}

export const ModifierGrid = ({ modifierGroups, menuId }: ModifierGridProps) => {
  return (
    <div
      className="grid grid-cols-[repeat(auto-fill,minmax(12.5rem,1fr))] gap-4"
      id="modifiersContainer"
    >
      {modifierGroups.map(
        (modifierGroup: NonNullable<typeof modifierGroups>[number]) => {
          const modifiersTotal =
            (modifierGroup.numberOfModifiers ?? 0) +
            (modifierGroup.numberOfSubModifiersGroups ?? 0);
          return (
            <Link
              className="group bg-muted hover:border-foreground focus-visible:border-foreground focus-visible:ring-md focus-visible:ring-ring/50 h-40 w-52 cursor-pointer rounded-2xl border border-transparent transition-[color,box-shadow] focus-visible:outline-hidden"
              key={modifierGroup._id}
              params={{ menuId, modifierGroupId: modifierGroup._id }}
              to="/menus/$menuId/modifiers/$modifierGroupId"
            >
              <div
                className="flex h-40 flex-col justify-between rounded-2xl px-4 py-3"
                key={modifierGroup._id}
              >
                <div className="space-y-1">
                  <p className="subtitle-sm text-foreground truncate overflow-x-hidden">
                    {modifierGroup.name}
                  </p>
                  <p className="body-sm text-muted-foreground">
                    {modifiersTotal} modifier
                    {modifiersTotal % 10 === 1 ? "" : "s"}
                  </p>
                </div>
                <div className="flex flex-row flex-wrap items-center gap-1">
                  <div
                    className={twJoin(
                      "caption flex items-center gap-1 rounded-full px-2 py-1",
                      modifierGroup.isSomeOutOfStock
                        ? "bg-destructive/10 text-destructive"
                        : "bg-success/10 text-success"
                    )}
                  >
                    <div
                      className={twJoin(
                        "size-1.5 rounded-full",
                        modifierGroup.isSomeOutOfStock
                          ? "bg-destructive"
                          : "bg-success"
                      )}
                    />
                    {modifierGroup.isSomeOutOfStock
                      ? "Some are out of stock"
                      : "Available"}
                  </div>
                  {"isShared" in modifierGroup && modifierGroup.isShared && (
                    <div className="caption bg-info/10 text-info rounded-full px-2 py-1">
                      Shared
                    </div>
                  )}
                </div>
              </div>
            </Link>
          );
        }
      )}
    </div>
  );
};
